// useGatewayApi.ts
import axios from "axios"

const clientId = 'realTimeWebClient'

function resolveServiceBase() {
  const host = document.location.host
  if (host === 'gildi.demo01.lisa.is') return 'https://gildi-gateway.demo01.lisa.is'
  if (host.includes('localhost')) return 'https://localhost:44316'
  if (host === 'sjodfelagavefur.gildi.is') return 'https://gateway-api.gildi.is'
  return ''
}

const apiClient = axios.create({
  baseURL: resolveServiceBase(),
  withCredentials: true,
  headers: { 'Content-Type': 'application/json; charset=utf-8' }
})

export default function useGatewayApi() {
  async function request(method: string, url: string, payload?: any, contentType?: string) {
    try {
      const headers: Record<string, string> = {}
      if (contentType) headers['Content-Type'] = contentType

      const config: any = { method, url, headers }
      if (method.toLowerCase() === 'get') config.params = payload
      else config.data = payload

      const response = await apiClient(config)
      return response.data
    } catch (error: any) {
      if (error.response?.status === 401) {
        window.location.replace(import.meta.env.VITE_AUTH_DOMAIN || '/logout')
      }
      console.error('API Error:', error)
      throw error
    }
  }

  async function requestFormData(method: string, url: string, payload: FormData) {
  try {
    const config = {
      method,
      url,
      headers: { 'Content-Type': 'multipart/form-data' },
      data: payload
    }
    const response = await apiClient(config)
    return response.data
  } catch (error: any) {
    if (error.response?.status === 401) {
      window.location.replace(import.meta.env.VITE_AUTH_DOMAIN || '/logout')
    }
    console.error('API Error:', error)
    throw error
  }
}

  /** NEW: binary request that PRESERVES HEADERS */
  async function getBinary(url: string) {
    const resp = await apiClient.request<ArrayBuffer>({
      method: 'get',
      url,
      // do NOT set Content-Type for GET
      responseType: 'arraybuffer',        // <-- critical
      transformResponse: (x) => x         // keep raw bytes
    })
    return { data: resp.data, headers: resp.headers }
  }

  const get = (url: string, data?: any) => request('get', url, data)
  const post = (url: string, data: any) => request('post', url, data)
  const postFile = (url: string, data: any) =>
    request('post', url, data, 'multipart/form-data')
  const put = (url: string, data: any) => request('put', url, data)
  const del = (url: string, data: any) => request('delete', url, data)

  function clearAuthentication() { localStorage.removeItem('token') }
  function authenticated(token: string, refreshToken?: string) { /* optional */ }

  return { clientId, get, post, postFile, put, del, clearAuthentication, authenticated, getBinary }
}
